// @ts-strict-ignore
import * as React from 'react';
import { antGrey } from '../components/styles/globalStyles';
import {
    FileImageOutlined,
    FileJpgOutlined,
    FilePdfOutlined,
    FileWordOutlined,
    FileTextOutlined,
    FileExcelOutlined,
    FileZipOutlined,
    FileOutlined,
    PlaySquareOutlined,
} from '@ant-design/icons';

export const iconForFileType = (fileName: string) => {
    const fileType = fileName.split('.').pop().toLowerCase().trim();
    const iconStyle: React.CSSProperties = {
        color: antGrey.grey6,
    };
    switch (fileType) {
        case 'png':
            return <FileImageOutlined style={iconStyle} />;
        case 'jpg':
            return <FileJpgOutlined style={iconStyle} />;
        case 'pdf':
            return <FilePdfOutlined style={iconStyle} />;
        case 'doc':
        case 'docx':
            return <FileWordOutlined style={iconStyle} />;
        case 'rtf':
        case 'pages':
            return <FileTextOutlined style={iconStyle} />;
        case 'xls':
        case 'xlsx':
            return <FileExcelOutlined style={iconStyle} />;
        case 'zip':
        case 'rar':
            return <FileZipOutlined style={iconStyle} />;
        case 'mp4':
        case 'avi':
            return <PlaySquareOutlined style={iconStyle} />;
        default:
            return <FileOutlined style={iconStyle} />;
    }
};
